import { createContext } from 'react'
const defaults = {
  reloadMe: () => {},
  setShowMessageAlert: () => {},
  setSuccessMessage: () => {}
}
export const AppContext = createContext(defaults)
